export default function valueClassname(value: string | null | undefined) {
  if (value === undefined) return '';
  if (value == null) return '';
  if (value === '') return '';
  if (value === 'All') return '';

  return 'has-value';
}
